import { render } from "./articleCardList.vue?vue&type=template&id=59a70694&scoped=true"
import script from "./articleCardList.vue?vue&type=script&lang=js"
export * from "./articleCardList.vue?vue&type=script&lang=js"

import "./articleCardList.vue?vue&type=style&index=0&id=59a70694&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a70694"]])

export default __exports__